import { makeAutoObservable, reaction } from 'mobx'
import { bannerStore, EnumAlertBannerVariant } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { SubscriptionStore } from 'entities/Subscription'
import type { OrganizationStore } from 'entities/Organization'
import { BillingPath } from 'entities/ExportRouters'

export class ReminderTrialCreditsStore {
  constructor(
    private _subscriptionStore: SubscriptionStore,
    private _organizationStore: OrganizationStore
  ) {
    makeAutoObservable(this)
  }

  bannerId = 'add_trial_credits'
  reactionAddTrialCredits: ReturnType<typeof reaction> | null = null

  get isOnTrial() {
    return this._subscriptionStore.isTrial
  }

  get isOutOfTrialCredits() {
    return this._organizationStore.isOutOfTrialCredits
  }

  get isOrganizationOwner() {
    return this._organizationStore.isOrganizationOwner
  }

  get noMessageSending() {
    return (
      this.isOnTrial && this.isOutOfTrialCredits && this._organizationStore.isBillableNumberVendor
    )
  }

  get show() {
    return this.noMessageSending
  }

  init = async () => {
    await Promise.all([this._organizationStore.initPromise, this._subscriptionStore.initPromise])
    this.handleReactionAddTrialCredits()
  }

  handleReactionAddTrialCredits = () => {
    if (this.reactionAddTrialCredits) this.reactionAddTrialCredits()

    this.reactionAddTrialCredits = reaction(
      () => this.show,
      (value) => {
        if (value) {
          if (this.isOrganizationOwner) {
            bannerStore.add({
              id: this.bannerId,
              action: {
                text: 'Upgrade now',
                onAction: () => uiStore.changeRouteViaVue({ path: `/${BillingPath.upgrade}` }),
              },
              alert: {
                title:
                  'Your organization is out of trial credits. Upgrade now to continue sending messages.',
                variant: EnumAlertBannerVariant.Info,
                ariaLabel: 'AddTrialCredits',
              },
            })
          } else {
            bannerStore.add({
              id: this.bannerId,
              alert: {
                title:
                  'Your organization is out of trial credits. Ask your organization owner to upgrade to continue sending messages.',
                variant: EnumAlertBannerVariant.Info,
                ariaLabel: 'AddTrialCredits',
              },
            })
          }
        } else {
          bannerStore.remove(this.bannerId)
        }
      },
      {
        fireImmediately: true,
      }
    )
  }
}
